// `?relay=wss://…` points the studio at another stream relay, for testing a
// relay build from local dev or a deploy preview. On the real site a crafted
// link would send the customer's stream key and live camera to whatever
// server it names, so there only our own relays are accepted.

const isLocalHost = (host) =>
  host === "localhost" || host.endsWith(".localhost") || host === "127.0.0.1" || host === "[::1]";

// Netlify deploy previews and branch deploys of this app.
const isPreviewHost = (host) => /^[a-z0-9-]+--eventlive-universal\.netlify\.app$/.test(host);

export function allowedRelayOverride(override, pageHostname) {
  if (!override) return null;
  let url;
  try {
    url = new URL(override);
  } catch {
    return null;
  }
  if (url.protocol !== "wss:" && url.protocol !== "ws:") return null;
  if (url.protocol === "wss:" && url.hostname.endsWith(".eventlive.pro")) return url.href;
  const page = String(pageHostname || "").toLowerCase();
  if (isLocalHost(page) || isPreviewHost(page)) return url.href;
  return null;
}
